import React from 'react';

const titleComponent = ({title}) => (
    <h1>{title}</h1>
);

export default titleComponent;


// WEBPACK FOOTER //
// ./src/Components/TitleComponent.js